import { createBox } from '@shopify/restyle';

import { AppTheme } from '../theme';

export const Box = createBox<AppTheme>();

export type BoxProps = React.ComponentProps<typeof Box>;
